// ==============================|| DEFAULT THEME - TYPOGRAPHY  ||============================== //

const Typography = (fontFamily) => ({
  htmlFontSize: 16,
  fontFamily,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '38.24px'
  },
  h2: {
    fontWeight: 700,
    fontSize: '28px',
    lineHeight: '33.6px'
  },
  h3: {
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '32px'
  },
  h4: {
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '31px'
  },
  h5: {
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: 1.5
  },
  h6: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: 1.57
  },
  caption: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.66
  },
  body1: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px'
  },
  body2: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px'
  },
  subtitle1: {
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: '21px'
  },
  subtitle2: {
    fontSize: '11px',
    fontWeight: 500,
    lineHeight: '20px'
  },
  overline: {
    lineHeight: 1.66
  },
  button: {
    textTransform: 'capitalize'
  }
});

export default Typography;
